<template>
  <div class="fund-size-holder">
    <VueEcharts :option="option" />
    <RkTable :data="holderData" :show-footer="false">
      <RkTableColumn prop="" label="日期" align="left"></RkTableColumn>
      <RkTableColumn prop="" label="机构"></RkTableColumn>
      <RkTableColumn prop="" label="个人"></RkTableColumn>
      <RkTableColumn prop="" label="其他"></RkTableColumn>
      <RkTableColumn prop="" label="总份额">
        <template #header>
          <p>总份额</p>
          <p>(亿元)</p>
        </template>
      </RkTableColumn>
    </RkTable>
  </div>
</template>

<script>
import VueEcharts from '@/components/common/VueEcharts.vue'
export default {
  components: { VueEcharts },
  data() {
    return {
      holderData: []
    }
  },
  computed: {
    option() {
      return {
        dataset: {
          source: this.holderData
        },
        series: [
          {
            name: '总份额',
            type: 'pie',
            radius: ['50%', '100%'],
            encode: {
              name: 'name',
              value: 'incomeRatio'
            },
            label: {
              show: false
            },
            emphasis: {
              disabled: true
            }
          }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fund-size-holder {
  padding: 0 var(--edge-padding) var(--edge-padding);
  background: var(--bg-color-2);
}
</style>
